import React, { Component } from 'react';

class NoData extends Component {
constructor(props){
    super(props);
}

//Return NO DATA
render(){
    return (
  <div className="noData_wrapper">
    <div className="noData_view">
        <div className="noData-container-inner"> 
            <p>No Data</p>
        </div>
     </div>
     </div>
      );
}
}
export default NoData;



// WEBPACK FOOTER //
// ./web/components/admin/common/NoData.js